import React from "react"
import { useTranslation } from "react-i18next"

const VariantChangeOver = ({
  label,
  value,
  active = false,
  containerType = "single",
}) => {
  const { t } = useTranslation()
  return (
    <div>
      {label ? label : t("generic.products.changeoverLabelFallback")}
      {": "}
      <span className={active ? "font-bold" : ""}>
        {value}
        {containerType === "set" && (
          <>{t("generic.products.changeoverSetSuffix")}</>
        )}
      </span>
    </div>
  )
}

export default VariantChangeOver
